// The id a drawn pair uses to find its own two halves. The chart and the grid are siblings with no
// element between them, and a page draws as many crossed pairs as the researcher asked for -- all
// of them naming their points the same `b<batch>a<variant>` -- so the pair cannot be resolved by
// position in the markup. The block mints one id and hands it to both.
//
// A counter rather than the question key: the info view can put the same question on two slides,
// and two blocks answering to one id would light each other's cells.
let counter = 0

export const nextBlockId = () => `cf-${++counter}`
